import { defineComponent, ref, computed } from 'vue-demi';
import { s as script$1 } from './OrIconButton-81bade23.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withModifiers } from 'vue';

var OrSidebarPlacement;
(function (OrSidebarPlacement) {
  OrSidebarPlacement["Left"] = "left";
  OrSidebarPlacement["Right"] = "right";
})(OrSidebarPlacement || (OrSidebarPlacement = {}));

const CollapseButton = [
// Box
'w-[24px]', 'h-[24px]', 'rounded-full',
// Theme
'text-primary dark:text-primary-dark', 'bg-background dark:bg-background-dark'];
const CollapseButtonButton = [
// Box
'w-[24px]', 'h-[24px]', 'rounded-full',
// Typography
'!text-[16px]',
// Borders
'!border-[1px]', '!border-solid',
// Theme
'!text-primary dark:!text-primary-dark', '!bg-background dark:!bg-background-dark', '!border-outline-variant dark:!border-outline-variant-dark', '!outline-none',
// Theme (hover)
'hover:!text-primary hover:dark:!text-primary-dark', 'hover:!bg-primary-opacity-0-08 dark:hover:!bg-primary-opacity-0-08-dark', 'hover:!border-outline dark:hover:!border-outline-dark',
// Theme (active)
'active:!text-primary active:dark:!text-primary-dark', 'active:!bg-primary-opacity-0-12 dark:active:!bg-primary-opacity-0-12-dark', 'active:!border-primary dark:active:!border-primary-dark',
// Theme (focus)
'focus:!text-primary focus:dark:!text-primary-dark', 'focus:!bg-primary-opacity-0-12 dark:focus:!bg-primary-opacity-0-12-dark', 'focus:!border-outline dark:focus:!border-outline-dark',
// Theme (disabled)
'disabled:!text-on-disabled disabled:dark:!text-on-disabled-dark', 'disabled:!bg-background disabled:dark:!bg-background-dark', 'disabled:!border-outline-variant disabled:dark:!border-outline-variant-dark'];

var script = defineComponent({
  name: 'OrSidebarCollapseButton',
  components: {
    OrIconButton: script$1
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    /**
     * Must be `true` if sidebar is collapsed.
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    side: {
      type: String,
      default: OrSidebarPlacement.Right
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    const rootStyles = computed(() => ['or-sidebar-collapse-button-v3', ...CollapseButton]);
    const buttonStyles = computed(() => [...CollapseButtonButton]);
    // State
    const icon = computed(() => {
      return props.side === OrSidebarPlacement.Left !== props.modelValue ? 'keyboard_arrow_left' : 'keyboard_arrow_right';
    });
    return {
      root,
      rootStyles,
      buttonStyles,
      icon
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: "root",
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrIconButton, {
    "additional-styles": _ctx.buttonStyles,
    icon: {
      icon: _ctx.icon,
      size: 'inherit'
    },
    color: 'inherit',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('update:modelValue', !_ctx.modelValue), ["stop"]))
  }, null, 8 /* PROPS */, ["additional-styles", "icon"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-sidebar-v3/partials/or-sidebar-collapse-button/OrSidebarCollapseButton.vue";

export { OrSidebarPlacement as O, script as s };
